import Vue from "vue";
import VueRouter from "vue-router";
import dpcpcRoutes from "@/router/docpc.js";
import staffRoutes from "@/router/PWstaff.js";

import Timeline from "@/views/apply/timeline.vue"; //结果页
import Blank from "@/views/apply/blank.vue"; //跳转页
import Login from "@/views/apply/login.vue"; //登录页
import Liveness from "@/views/apply/liveness.vue"; //人脸识别
import Ocr from "@/views/apply/ocr.vue"; //身份识别+人脸识别
import BeforeApply from "@/views/apply/beforeApply.vue"; //知情同意书
import Apply from "@/views/apply/apply.vue"; //基本信息
import Upload from "@/views/apply/upload.vue"; //上传材料
import UploadItem from "@/views/apply/uploadItem.vue"; //上传材料单项
import MailPaperMaterials from "@/views/apply/mailPaperMaterials.vue"; //邮寄纸质材料
import Materials from "@/views/apply/materials.vue"; //纸质材料详情 
import Appointment from "@/views/apply/appointment.vue"; //预约用药
import DrugInfo from "@/views/apply/drugInfo.vue"; //领药提示
import applyDownload from "@/views/apply/download.vue"; //药品领取单下载
import ChooseTime from "@/views/apply/chooseTime.vue"; //开启下一阶段
//代领药人
import AgentReceiving from "@/views/apply/agentReceiving.vue"; //代领药人还是本人领药
import AgentManage from "@/views/apply/agentManage.vue"; //代领药人管理
import AddAgent from "@/views/apply/addAgent.vue"; //添加/修改代领药人
import AgentUpload from "@/views/apply/agentUpload.vue"; //代领药人材料上传
import AgentUploadItem from "@/views/apply/agentUploadItem.vue"; //代领药人材料上传
import RecordVideo from "@/views/apply/RecordVideo.vue"; //视频拍摄


//import Msg from "@/views/apply/msg.vue"; //消息页
import Query from "@/views/apply/query.vue"; //结果页

// import GetMedicine from "@/views/apply/getMedicine.vue"; //领药详情


// import Manage from "@/views/substitute/manage.vue"; //代领药人管理
// import AddReplace from "@/views/substitute/addReplace.vue"; //添加代领药人信息
// import UploadReplace from "@/views/substitute/uploadReplace.vue"; //材料上传

// import Express from "@/views/apply/express.vue"; //快递查询

import Out from "@/views/apply/out.vue"; //出组

import ReApply from "@/views/referral/apply.vue"; //转诊选择
import ReChange from "@/views/referral/change.vue"; //转诊申请

import DoctorQuery from "@/views/doctor/doctorQuery"//医生通道状态查询跳转中转页面
import DoctorLogin from "@/views/doctor/doctorLogin"//医生通道登陆首页
import DoctorReg from "@/views/doctor/doctorRegister"//医生通道基本信息录入
import DoctorMsg from "@/views/doctor/doctorMsg"//医生通道提交信息提示
import RecordTable from "@/views/doctor/recordTable"//医生通道备案表上传和下载
import SealReceive from "@/views/doctor/sealReceive"//医生通道印章接收页面
import UnderstandingText from "@/views/doctor/understandingText"//医生通道印章接收页面
import ExamIndex from "@/views/doctor/examIndex"//医生通道考试页面首页
import ExamVideo from "@/views/doctor/examVideo"//医生通道考试页面视频
import SingleChoiceExam from "@/views/doctor/singleChoiceExam"//医生通道考试页面单选题
import MultipleChoicesExam from "@/views/doctor/multipleChoicesExam"//医生通道考页面多选题




import Download from "@/views/project/download.vue"; //资料下载
import Download2 from "@/views/project/download2.vue"; //资料下载 非小细胞
import Introduce from "@/views/project/introduce.vue"; //项目介绍
import IntroduceDetail from "@/views/project/introduce-detail.vue"; //项目介绍
// import Process from "@/views/project/process.vue"; //项目流程
import Notice from "@/views/project/notice.vue"; //项目公告
import NoticeDetail from "@/views/project/notice-detail.vue"; //项目公告详情
import Page from "@/views/project/page.vue"; //联系我们
import Express from "@/views/project/express.vue"; //联系我们

import Map from "@/views/organization/map.vue"; //合作机构
import MapDetail from "@/views/organization/mapDetail.vue"; //合作机构详情-药房医院志愿者

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Blank",
    component: Blank,
    meta: {
      title: "跳转中",
    },
  },
  {
    path: "/apply/login",
    name: "Login",
    component: Login,
    meta: {
      title: "在线注册/登录",
    },
  },
  {
    path: "/apply/before_apply",
    name: "BeforeApply",
    component: BeforeApply,
    meta: {
      title: "在线申请",
    },
  },
  {
    path: "/apply/ocr",
    name: "Ocr",
    component: Ocr,
    meta: {
      title: "立即申请",
    },
  },
  {
    path: "/apply/before_apply",
    name: "BeforeApply",
    component: BeforeApply,
    meta: {
      title: "立即申请",
    },
  },
  {
    path: "/apply/apply",
    name: "Apply",
    component: Apply,
    meta: {
      title: "预约申请",
    },
  },
  {
    path: "/apply/liveness",
    name: "Liveness",
    component: Liveness,
    meta: {
      title: "用户信息验证",
    },
  },
  {
    path: "/apply/upload",
    name: "Upload",
    component: Upload,
    meta: {
      title: "电子预审核",
    },
  },
  {
    path: "/apply/uploadItem",
    name: "UploadItem",
    component: UploadItem,
    meta: {
      title: "电子预审核",
    },
  },
  {
    path: "/apply/mailPaperMaterials",
    name: "MailPaperMaterials",
    component: MailPaperMaterials,
    meta: {
      title: "邮寄材料",
    },
  },
  {
    path: "/apply/materials",
    name: "Materials",
    component: Materials,
    meta: {
      title: "邮寄材料",
    },
  },
  {
    path: "/apply/appointment",
    name: "Appointment",
    component: Appointment,
    meta: {
      title: "预约用药",
    },
  },
  {
    path: "/apply/drugInfo",
    name: "DrugInfo",
    component: DrugInfo,
    meta: {
      title: "领药提示",
    },
  },
  {
    path: "/apply/agentReceiving",
    name: "AgentReceiving",
    component: AgentReceiving,
    meta: {
      title: "领药信息确认",
    },
  },
  {
    path: "/apply/agentManage",
    name: "AgentManage",
    component: AgentManage,
    meta: {
      title: "代领药人管理",
    },
  },
  {
    path: "/apply/addAgent",
    name: "AddAgent",
    component: AddAgent,
    meta: {
      title: "新增代领药人",
    },
  },
  {
    path: "/apply/agentUpload",
    name: "AgentUpload",
    component: AgentUpload,
    meta: {
      title: "上传代领材料",
    },
  },
  {
    path: "/apply/agentUploadItem",
    name: "AgentUploadItem",
    component: AgentUploadItem,
    meta: {
      title: "上传代领材料",
    },
  },
  {
    path: "/apply/download",
    name: "applyDownload",
    component: applyDownload,
    meta: {
      title: "药品领取单下载",
    },
  },
  {
    path: "/apply/chooseTime",
    name: "ChooseTime",
    component: ChooseTime,
    meta: {
      title: "选择输注时间",
    },
  },
  // {
  //   path: "/apply/msg",
  //   name: "Msg",
  //   component: Msg,
  //   meta: {
  //     title: "择美同行",
  //   },
  // },
  {
    path: "/apply/query",
    name: "Query",
    component: Query,
    meta: {
      title: "择美同行",
    },
  },
  {
    path: "/apply/timeline",
    name: "Timeline",
    component: Timeline,
    meta: {
      title: "我的主页",
    },
  },

  {
    path: "/apply/out",
    name: "Out",
    component: Out,
    meta: {
      title: "出组",
    },
  },
  // {
  //   path: "/apply/getMedicine",
  //   name: "GetMedicine",
  //   component: GetMedicine,
  //   meta: {
  //     title: "领药信息",
  //   },
  // },
  {
    path: "/doctor/doctor_query",
    name: "DoctorQuery",
    component: DoctorQuery,
    meta: {
      title: "我的主页",
    },
  },
  {
    path: "/doctor/exam_index",
    name: "ExamIndex",
    component: ExamIndex,
    meta: {
      title: "医生考试",
    },
  },
  {
    path: "/doctor/exam_video",
    name: "ExamVideo",
    component: ExamVideo,
    meta: {
      title: "视频学习",
    },
  },
  {
    path: "/doctor/doctor_login",
    name: "DoctorLogin",
    component: DoctorLogin,
    meta: {
      title: "医生登录",
    },
  },
  {
    path: "/doctor/doctor_reg",
    name: "DoctorReg",
    component: DoctorReg,
    meta: {
      title: "医生信息登记",
    },
  },
  {
    path: "/doctor/msg",
    name: "DoctorMsg",
    component: DoctorMsg,
    meta: {
      title: "提交成功",
    },
  },
  {
    path: "/doctor/Understanding_text",
    name: "UnderstandingText",
    component: UnderstandingText,
    meta: {
      title: "项目医生备案",
      scrollToTop: true,
    },
  },
  {
    path: "/doctor/record_table",
    name: "RecordTable",
    component: RecordTable,
    meta: {
      title: "项目医生备案",
      scrollToTop: true,
    },
  },
  {
    path: "/doctor/seal_receive",
    name: "SealReceive",
    component: SealReceive,
    meta: {
      title: "印章接收",
    },
  },
  {
    path: "/doctor/single_choice_exam",
    name: "SingleChoiceExam",
    component: SingleChoiceExam,
    meta: {
      title: "医生考试",
      scrollToTop: true,
    },
  },
  {
    path: "/doctor/multiple_choices_exam",
    name: "MultipleChoicesExam",
    component: MultipleChoicesExam,
    meta: {
      title: "医生考试",
      scrollToTop: true,
    },
  },
  {
    path: "/organization/mapDetail",
    name: "MapDetail",
    component: MapDetail,
    meta: {
      title: "合作机构",
    },
  },
  {
    path: "/organization/map",
    name: "Map",
    component: Map,
    meta: {
      title: "合作机构",
    },
  },
  {
    path: "/project/download",
    name: "Download",
    component: Download,
    meta: {
      title: "资料下载",
    },
  },
  {
    path: "/project/downloadfx",
    name: "Download2",
    component: Download2,
    meta: {
      title: "资料下载",
    },
  },
  {
    path: "/project/introduce",
    name: "Introduce",
    component: Introduce,
    meta: {
      title: "项目介绍",
    },
  },
  {
    path: "/project/introduceDetail",
    name: "IntroduceDetail",
    component: IntroduceDetail,
    meta: {
      title: "详情",
    },
  },
  // {
  //   path: "/project/process",
  //   name: "Process",
  //   component: Process,
  //   meta: {
  //     title: "项目流程",
  //   },
  // },
  {
    path: "/project/notice",
    name: "Notice",
    component: Notice,
    meta: {
      title: "项目公告",
    },
  },
  {
    path: "/project/noticeDetail",
    name: "NoticeDetail",
    component: NoticeDetail,
    meta: {
      title: "项目详情",
    },
  },
  {
    path: "/project/page",
    name: "Page",
    component: Page,
    meta: {
      title: "项目详情",
    },
  },
  {
    path: "/project/express",
    name: "Express",
    component: Express,
    meta: {
      title: "快递查询",
    },
  },
  // {
  //   path: "/substitute/manage",
  //   name: "Manage",
  //   component: Manage,
  //   meta: {
  //     title: "代领药人管理",
  //   },
  // },
  // {
  //   path: "/substitute/add_replace",
  //   name: "AddReplace",
  //   component: AddReplace,
  //   meta: {
  //     title: "添加代领药人信息",
  //   },
  // },
  // {
  //   path: "/substitute/upload_replace",
  //   name: "UploadReplace",
  //   component: UploadReplace,
  //   meta: {
  //     title: "材料上传",
  //   },
  // },
  {
    path: "/referral/apply",
    name: "ReApply",
    component: ReApply,
    meta: {
      title: "转诊申请",
    },
  },
  {
    path: "/referral/change",
    name: "ReChange",
    component: ReChange,
    meta: {
      title: "转诊申请",
    },
  },
  {
    path: "/apply/record_video",
    name: "RecordVideo",
    component: RecordVideo,
    meta: {
      title: "视频拍摄",
    },
  },
  ...dpcpcRoutes,
  ...staffRoutes,
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

export default router;